import type { ApiSuccess, AppVersionCheck, AppVersionCheckQuery } from '@capsico/contracts';
import { api } from './client';

/* W23 "please update": the public version check (no sign-in needed). */

/** Asks whether this build is still supported. Throws on 404 (feature off) and network errors. */
export async function fetchAppVersion(query: AppVersionCheckQuery): Promise<AppVersionCheck> {
  const res = await api.get<ApiSuccess<AppVersionCheck>>('/v1/app/version', { params: query });
  return res.data.data;
}
